import { render, staticRenderFns } from "./RateTrimBotComponent.vue?vue&type=template&id=65c30ec8"
import script from "./RateTrimBotComponent.vue?vue&type=script&lang=ts"
export * from "./RateTrimBotComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports